(() => {
  const root = (document.documentElement.dataset.vrRoot || '/').replace(/\/?$/, '/');
  const text = document.documentElement.dataset;
  const setImage = (image, source, alt) => {
    if (!image || !source) return;
    const widths = image.classList.contains('vr-card__photo') ? [240, 360, 480, 640, 800] : [360, 540, 800, 1100, 1400];
    const url = new URL(source, document.baseURI);
    image.srcset = widths.map(width => {
      url.searchParams.set('width', String(width));
      return url.href + ' ' + width + 'w';
    }).join(', ');
    url.searchParams.set('width', String(widths[widths.length - 1]));
    image.src = url.href;
    image.alt = alt || '';
  };
  const chooseVariant = (control, product) => {
    if (!product) return;
    const data = control.dataset;
    const input = product.querySelector('[data-vr-variant-input]');
    if (input) input.value = control.value || data.vrVariant;
    product.querySelectorAll('[data-vr-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === control)));
    const price = product.querySelector('[data-vr-price]');
    if (price) price.textContent = data.vrPriceValue;
    const compare = product.querySelector('[data-vr-compare]');
    if (compare) { compare.textContent = data.vrCompareValue || ''; compare.hidden = !data.vrCompareValue; }
    const label = product.querySelector('[data-vr-colour]');
    if (label) label.textContent = data.vrLabel;
    const lenses = product.querySelector('[data-vr-lens-description]');
    if (lenses && data.vrLenses) lenses.textContent = data.vrLenses;
    const image = product.querySelector('.vr-card__photo, .vr-pdp-image');
    if (image && data.vrImage) {
      setImage(image, data.vrImage, (product.querySelector('h1, h3')?.textContent.trim() || '') + ' · ' + data.vrLabel);
      const selectedPath = new URL(data.vrImage, document.baseURI).pathname;
      product.querySelectorAll('[data-vr-thumbnail]').forEach(thumbnail => thumbnail.setAttribute('aria-pressed', String(new URL(thumbnail.dataset.vrThumbnail, document.baseURI).pathname === selectedPath)));
    }
    product.querySelectorAll('[data-vr-product-link]').forEach(link => link.href = data.vrUrl);
    const button = product.querySelector('[data-vr-add-button]');
    if (button) { button.disabled = data.vrAvailable !== 'true'; button.querySelector('[data-vr-button-text]').textContent = button.disabled ? button.dataset.vrSoldLabel : button.dataset.vrAddLabel; }
    const quantity = product.querySelector('input[name="quantity"]');
    if (quantity && data.vrMin) { quantity.min = data.vrMin; quantity.step = data.vrIncrement || '1'; if (data.vrMax) quantity.max = data.vrMax; else quantity.removeAttribute('max'); quantity.value = data.vrMin; }
    if (product.hasAttribute('data-vr-pdp') && data.vrUrl) history.replaceState(null, '', data.vrUrl + location.hash);
    refreshCapriOffers();
  };
  const refreshCapriOffers = () => {
    const state = document.querySelector('[data-vr-cart-fragment]');
    document.querySelectorAll('[data-vr-capri-offer]').forEach(offer => {
      const data = (state || offer).dataset;
      const eligible = Number(data.vrCapriEligibleCount || 0);
      const capri = Number(data.vrCapriCount || 0);
      offer.hidden = data.vrCapriApplied === 'true' || (offer.dataset.vrCapriContext === 'cart' && eligible === 0);
      const button = offer.querySelector('[data-vr-capri-add]');
      const variant = offer.querySelector('[data-vr-capri-select]')?.selectedOptions[0];
      const primary = document.getElementById(offer.dataset.vrPrimaryForm);
      if (!button || !variant || button.getAttribute('aria-busy') === 'true') return;
      button.textContent = eligible >= 2 && capri > 0 ? offer.dataset.vrCapriApplyLabel : eligible > 0 ? offer.dataset.vrCapriAddLabel : offer.dataset.vrCapriPairLabel;
      button.disabled = variant.dataset.vrCapriAvailable !== 'true' || (eligible === 0 && (!primary || primary.querySelector('[data-vr-add-button]')?.disabled));
    });
  };
  const updateCapriVariant = select => {
    const offer = select.closest('[data-vr-capri-offer]');
    const option = select.selectedOptions[0];
    if (!offer || !option) return;
    offer.querySelector('[data-vr-capri-price]').textContent = option.dataset.vrCapriPriceValue;
    offer.querySelector('[data-vr-capri-original]').textContent = option.dataset.vrCapriOriginalValue;
    const image = offer.querySelector('.vr-capri-offer__image');
    if (image && option.dataset.vrCapriImage) { image.srcset = ''; image.src = option.dataset.vrCapriImage; image.alt = 'Capri · ' + option.dataset.vrCapriColour; }
    const error = offer.querySelector('[data-vr-capri-error-message]');
    if (error) error.hidden = true;
    refreshCapriOffers();
  };
  const capriCartState = (cart, offer) => {
    const eligibleIds = new Set(offer.dataset.vrCapriEligibleIds.split(','));
    let eligible = 0;
    let capri = 0;
    let applied = false;
    const codes = new Set();
    const collectDiscount = allocation => {
      const application = allocation.discount_application || allocation;
      if (application.type === 'discount_code' && application.title) codes.add(application.title);
      return [offer.dataset.vrCapriCode.toUpperCase(), 'CAPRI · 50% OFF'].includes((application.title || '').toUpperCase());
    };
    for (const item of cart.items || []) {
      if (eligibleIds.has(String(item.product_id))) eligible += item.quantity;
      const isCapri = String(item.product_id) === offer.dataset.vrCapriProductId;
      if (isCapri) capri += item.quantity;
      for (const allocation of item.line_level_discount_allocations || []) {
        if (collectDiscount(allocation) && isCapri && allocation.amount > 0) applied = true;
      }
    }
    for (const application of cart.cart_level_discount_applications || []) collectDiscount(application);
    return { eligible, capri, applied, codes };
  };
  const capriRequest = async (path, body) => {
    const options = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' };
    const response = await fetch(root + path, options);
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || text.vrError);
    return result;
  };
  const openCart = () => {
    const dialog = document.getElementById('vr-cart-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') { location.assign(root + 'cart'); return; }
    if (!dialog.open) dialog.showModal();
  };
  const replaceCart = (sections, open = false) => {
    const html = sections?.['vr-cart-drawer'];
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fragment = parsed.querySelector('[data-vr-cart-fragment]');
    const current = document.querySelector('[data-vr-cart-fragment]');
    if (!fragment || !current) return false;
    document.getElementById('vr-cart-dialog')?.close();
    current.replaceWith(fragment);
    refreshCapriOffers();
    document.querySelectorAll('[data-vr-cart-count]').forEach(count => { count.textContent = fragment.dataset.vrItemCount; count.hidden = Number(fragment.dataset.vrItemCount) === 0; });
    if (open) openCart();
    return true;
  };
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-vr-filters]');
    if (!form || !window.FormData) return;
    event.preventDefault();
    event.stopPropagation();
    if (form.dataset.vrSubmitting === 'true') return;
    const destination = new URL(form.action, location.origin);
    for (const [key, value] of new FormData(form)) {
      if (typeof value === 'string' && value.trim()) destination.searchParams.append(key, value.trim());
    }
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) destination.searchParams.set('preview_theme_id', preview);
    form.dataset.vrSubmitting = 'true';
    form.setAttribute('aria-busy', 'true');
    const button = form.querySelector('[data-vr-apply]');
    if (button) { button.disabled = true; button.textContent = button.dataset.vrUpdating; }
    location.assign(destination.href);
  }, true);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-vr-filters]').forEach(form => {
      form.dataset.vrSubmitting = 'false';
      form.removeAttribute('aria-busy');
      const button = form.querySelector('[data-vr-apply]');
      if (button) { button.disabled = false; button.textContent = button.dataset.vrApplyLabel || button.textContent; }
    });
  });
  document.querySelectorAll('[data-vr-apply]').forEach(button => button.dataset.vrApplyLabel = button.textContent);
  let cartBusy = false;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-vr-add]');
    if (!form || !window.fetch || !window.FormData) return;
    event.preventDefault();
    if (cartBusy || form.dataset.vrBusy === 'true') return;
    cartBusy = true;
    form.dataset.vrBusy = 'true';
    const button = form.querySelector('[data-vr-add-button]');
    const error = form.querySelector('[data-vr-error]');
    const oldLabel = button?.querySelector('[data-vr-button-text]')?.textContent;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.querySelector('[data-vr-button-text]').textContent = text.vrAdding; }
    if (error) error.hidden = true;
    const body = new FormData(form);
    body.set('sections', 'vr-cart-drawer');
    body.set('sections_url', location.pathname);
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || text.vrError);
      const announcer = document.querySelector('[data-vr-announcer]');
      if (announcer) announcer.textContent = text.vrAdded;
      if (!replaceCart(result.sections, true)) location.assign(root + 'cart');
    } catch (failure) {
      if (error) { error.textContent = failure.message || text.vrError; error.hidden = false; }
    } finally {
      cartBusy = false;
      form.dataset.vrBusy = 'false';
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.querySelector('[data-vr-button-text]').textContent = oldLabel; }
    }
  });
  document.addEventListener('change', event => {
    const capriSelect = event.target.closest('[data-vr-capri-select]');
    if (capriSelect) updateCapriVariant(capriSelect);
    const select = event.target.closest('[data-vr-variant-select]');
    if (select) chooseVariant(select.selectedOptions[0], select.closest('[data-vr-product]'));
    const localization = event.target.closest('[data-vr-localization]');
    if (localization) localization.form.requestSubmit();
  });
  document.addEventListener('click', async event => {
    const capriButton = event.target.closest('[data-vr-capri-add]');
    if (capriButton && window.fetch) {
      event.preventDefault();
      if (cartBusy) return;
      const offer = capriButton.closest('[data-vr-capri-offer]');
      const select = offer.querySelector('[data-vr-capri-select]');
      const error = offer.querySelector('[data-vr-capri-error-message]');
      const oldLabel = capriButton.textContent;
      cartBusy = true;
      capriButton.disabled = true;
      capriButton.setAttribute('aria-busy', 'true');
      capriButton.textContent = text.vrAdding;
      if (error) error.hidden = true;
      try {
        const cart = await capriRequest('cart.js');
        const state = capriCartState(cart, offer);
        if (select.selectedOptions[0]?.dataset.vrCapriAvailable !== 'true') throw new Error(offer.dataset.vrCapriUnavailable);
        const items = [];
        if (!(state.eligible >= 2 && state.capri > 0)) {
          if (state.eligible === 0) {
            const primary = document.getElementById(offer.dataset.vrPrimaryForm);
            if (!primary) throw new Error(offer.dataset.vrCapriRequired);
            if (!primary.reportValidity()) return;
            const values = new FormData(primary);
            if (primary.querySelector('[data-vr-add-button]')?.disabled) throw new Error(offer.dataset.vrCapriUnavailable);
            const quantity = Number(values.get('quantity') || 1);
            const id = Number(values.get('id'));
            if (!Number.isInteger(quantity) || quantity < 1 || !id) throw new Error(offer.dataset.vrCapriRequired);
            const eligibleIds = new Set(offer.dataset.vrCapriEligibleIds.split(','));
            if (!eligibleIds.has(primary.closest('[data-vr-product]')?.dataset.vrProductId)) throw new Error(offer.dataset.vrCapriRequired);
            items.push({ id, quantity });
          }
          items.push({ id: Number(select.value), quantity: 1 });
        }
        if (items.length) await capriRequest('cart/add.js', { items });
        state.codes.add(offer.dataset.vrCapriCode);
        const updated = await capriRequest('cart/update.js', { discount: Array.from(state.codes).join(','), sections: ['vr-cart-drawer'], sections_url: location.pathname });
        const applied = capriCartState(updated, offer).applied;
        if (!applied) {
          replaceCart(updated.sections, true);
          const cartError = document.querySelector('[data-vr-cart-error]');
          if (cartError) { cartError.textContent = offer.dataset.vrCapriError; cartError.hidden = false; }
          throw new Error(offer.dataset.vrCapriError);
        }
        const announcer = document.querySelector('[data-vr-announcer]');
        if (announcer) announcer.textContent = text.vrAdded;
        if (offer.closest('.vr-cart-page') || !replaceCart(updated.sections, true)) location.assign(root + 'cart');
      } catch (failure) {
        if (error) { error.textContent = failure.message || offer.dataset.vrCapriError; error.hidden = false; }
      } finally {
        cartBusy = false;
        capriButton.removeAttribute('aria-busy');
        capriButton.textContent = oldLabel;
        refreshCapriOffers();
      }
      return;
    }
    const variant = event.target.closest('[data-vr-variant]');
    if (variant) chooseVariant(variant, variant.closest('[data-vr-product]'));
    const thumbnail = event.target.closest('[data-vr-thumbnail]');
    if (thumbnail) {
      const gallery = thumbnail.closest('.vr-gallery');
      const image = gallery.querySelector('.vr-pdp-image');
      setImage(image, thumbnail.dataset.vrThumbnail, thumbnail.dataset.vrImageAlt);
      gallery.querySelectorAll('[data-vr-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
    }
    const opener = event.target.closest('[data-vr-open-cart]');
    if (opener) { event.preventDefault(); openCart(); }
    if (event.target.closest('[data-vr-close-cart]')) document.getElementById('vr-cart-dialog')?.close();
    if (event.target.id === 'vr-cart-dialog') {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const remove = event.target.closest('#vr-cart-dialog [data-vr-remove]');
    if (remove && window.fetch) {
      event.preventDefault();
      if (cartBusy) return;
      cartBusy = true;
      remove.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: remove.dataset.vrRemove, quantity: 0, sections: ['vr-cart-drawer'], sections_url: location.pathname }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || text.vrError);
        if (!replaceCart(result.sections, true)) location.assign(root + 'cart');
      } catch (failure) {
        const error = document.querySelector('[data-vr-cart-error]');
        if (error) { error.textContent = failure.message || text.vrError; error.hidden = false; }
      } finally { cartBusy = false; remove.removeAttribute('aria-busy'); }
    }
    if (event.target.closest('.vr-mobile-nav a')) document.querySelector('.vr-mobile-menu')?.removeAttribute('open');
    if (!event.target.closest('.vr-nav-dropdown')) document.querySelectorAll('.vr-nav-dropdown[open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.vr-mobile-menu[open], .vr-nav-dropdown[open]').forEach(menu => menu.removeAttribute('open')); });
  const initialize = () => {
    document.querySelectorAll('[data-vr-localization]').forEach(select => select.dataset.vrReady = 'true');
    refreshCapriOffers();
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
